import React from 'react';
import {computed} from 'mobx';
import {observer} from 'mobx-react';
import store from '../s';

interface IMessageComponentProps {
    msgType: ICheckoutMessageType;
}

@observer
export default class MessageComponent extends React.Component<IMessageComponentProps, any> {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <span>
                {store.checkout.messages
                    .filter(m => m.msgType === this.props.msgType)
                    .map((o, _i) => (
                        <span
                            key={_i}
                            className="pad-left"
                        >
                            <span className="badge bg-danger">{o.msg}</span>
                        </span>
                    ))}
            </span>
        );
    }
}

interface IInputErrorComponent {
    v: IValidationObject;
}

@observer
export class InputError extends React.Component<IInputErrorComponent, any> {
    constructor(props) {
        super(props);
    }

    @computed get show() {
        return this.props.v.isError;
    }

    render() {
        // if (this.show){
        //     return (
        //         <span />
        //     );
        // } else {
        return <div className="input-error">{this.props.v.msg}</div>;
        // }
    }
}
